import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button
} from '@mui/material';
import {
  Phone,
  Email,
  LocationOn,
  Facebook,
  Instagram
} from '@mui/icons-material';

const Contact = () => {
  // Brand colors: Orange and Navy Blue
  const brandOrange = '#FF6B35';
  const brandNavy = '#1a237e';

  const contactInfo = [
    {
      icon: <Phone sx={{ fontSize: 40, color: brandNavy }} />,
      title: 'Telefon',
      details: ['+48 601 916 163', '+48 607 526 312'],
      action: 'Zadzwoń'
    },
    {
      icon: <Email sx={{ fontSize: 40, color: brandOrange }} />,
      title: 'Email',
      details: ['madacar@wp.pl', 'madacar@o2.pl'],
      action: 'Napisz'
    },
    {
      icon: <LocationOn sx={{ fontSize: 40, color: brandNavy }} />,
      title: 'Adres',
      details: ['Marina Ryn', 'ul. Portowa 15', '11-520 Ryn, Mazury'],
      action: 'Zobacz na mapie'
    }
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: brandNavy,
              mb: 2,
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            Kontakt
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: '#555',
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.6
            }}
          >
            Skontaktuj się z nami, aby zarezerwować swój wymarzony rejs po Mazurach.
          </Typography>
        </Box>

        {/* Contact Information */}
        <Grid container spacing={4} justifyContent="center">
          {contactInfo.map((info, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  backgroundColor: 'white',
                  border: `2px solid ${index === 1 ? brandOrange : brandNavy}`,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: `0 8px 30px ${index === 1 ? 'rgba(255, 107, 53, 0.3)' : 'rgba(26, 35, 126, 0.3)'}`
                  }
                }}
              >
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                  <Box sx={{ mb: 3 }}>
                    {info.icon}
                  </Box>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      color: brandNavy,
                      mb: 3
                    }}
                  >
                    {info.title}
                  </Typography>
                  {info.details.map((detail, idx) => (
                    <Typography
                      key={idx}
                      variant="h6"
                      sx={{
                        color: '#555',
                        mb: 1,
                        fontWeight: idx === 0 ? 600 : 400
                      }}
                    >
                      {detail}
                    </Typography>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Social Media */}
        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: brandNavy,
              mb: 4
            }}
          >
            Śledź Nas
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<Facebook />}
              onClick={() => window.open('https://www.facebook.com/madacarczartery', '_blank', 'noopener,noreferrer')}
              sx={{
                backgroundColor: brandNavy,
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                borderRadius: 3,
                '&:hover': { backgroundColor: '#283593' }
              }}
            >
              Facebook
            </Button>
            <Button
              variant="contained"
              size="large"
              startIcon={<Instagram />}
              sx={{
                backgroundColor: '#d737b6',
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                borderRadius: 3,
                '&:hover': { backgroundColor: '#eb4181' }
              }}
            >
              Instagram
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Contact;
